<div class="img--container">
  <img
    class="cross--icon"
    [class]="lang.isRTL ? 'rtl--close' : ''"
    src="assets/img/cross.png"
    [mat-dialog-close]
  />
  <img class="w-100" [src]="data?.src" />
</div>
